import React from 'react';

import cn from 'classnames';

import { UiText } from '@shared/ui';

import cls from './InfoItem.module.css';

interface InfoItemProps {
    classes?: string;
    label: string;
    children?: React.ReactNode;
}

export const InfoItem = ({ classes, label, children }: InfoItemProps) => (
    <div className={cn(cls.InfoItem, [classes])}>
        <UiText variant="mediumPlain" classes={cls.infoItemLabel}>
            {label}
        </UiText>
        <div className={cls.infoItemValue}>{children}</div>
    </div>
);
